import { render, staticRenderFns } from "./CaFiltro.vue?vue&type=template&id=12f4d2ea"
import script from "./CaFiltro.vue?vue&type=script&lang=js"
export * from "./CaFiltro.vue?vue&type=script&lang=js"
import style0 from "./CaFiltro.vue?vue&type=style&index=0&id=12f4d2ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
